import React, { Fragment, useState } from 'react'
import cn from 'classnames';
import { Tab } from '@headlessui/react'
import { useSelector } from 'react-redux';
import { selectCurrent } from '../../../../redux/settings/selectors';
import _ from 'lodash';
import useWindowDimensions from '../../../../hooks/useWindowsDimensions';

export default function TabContainer({ tabItems }: any) {
  const [color, setColor] = useState('universal')
  const result = useSelector(selectCurrent)
  const { height, width } = useWindowDimensions();
  const { header, footer, visible, sidebar, theme, primary, secondary } = result
  const filteredTabData: any = _.filter(tabItems, ['isVisible', true])
  return (
    <>
      {width && width < 720 ? <div className='w-full mt-4 bg-white'>
        <Tab.Group>
          <Tab.List className="mt-3 px-2 flex flex-wrap border-b border-white-light dark:border-[#191e3a]">
            {filteredTabData.map((tab: any) => (
              <Tab as={Fragment} key={tab.id}>
                {({ selected }) => (
                  <button
                    className={`${tab.isVisible ? 'visible' : 'hidden'}
                    ${selected
                        ? '!border-skin-primary !border-b-white text-skin-primary dark:!border-[#191e3a] dark:!border-b-black'
                        : ''
                      } p-3.5 py-2 -mb-[1px] flex items-center border border-transparent hover:text-danger !outline-none transition duration-300`}
                  >
                    {/* <svg>...</svg> */}
                    {tab.title}
                  </button>
                )}
              </Tab>
            ))}
          </Tab.List>
          <Tab.Panels className=" mx-2">
            {filteredTabData.map((tab: any, idx: any) => (
              <Tab.Panel key={idx}>
                <div className="active pt-2">{tab.component}</div>
              </Tab.Panel>
            ))}
          </Tab.Panels>
        </Tab.Group>
      </div> :
        <div className={` sm:px-0 bg-white w-full ${sidebar ? `max-w-[calc(100vw-20rem)]` : `max-w-[calc(100vw-2rem)]`}`}>
          <Tab.Group>
            <Tab.List className="mt-3 mx-2 flex flex-wrap border-b border-white-light dark:border-[#191e3a]">
              {filteredTabData.map((tab: any) => (
                <Tab as={Fragment} key={tab.id}>
                  {({ selected }) => (
                    <button
                      className={`${tab.isVisible ? 'visible' : 'hidden'}
                    ${selected
                          ? '!border-skin-primary !border-b-white text-skin-primary dark:!border-[#191e3a] dark:!border-b-black'
                          : ''
                        } p-3.5 py-2 -mb-[1px] flex items-center border border-transparent hover:text-danger !outline-none transition duration-300`}
                    >
                      {/* <svg>...</svg> */}
                      {tab.title}
                    </button>
                  )}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels className=" mx-2">
              {filteredTabData.map((tab: any, idx: any) => (
                <Tab.Panel key={idx}>
                  <div className="active pt-2">{tab.component}</div>
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </Tab.Group>
        </div>}
    </>

  )
}
